import { ReactComponent as StepsSvg } from "../svgs/steps.svg";
import React from "react";
import { useSteps } from "../useSteps";
import { AllSteps } from "../AllSteps";

export const GotoAllStepsButton = ({ isCameraActive }) => {
  const { openAllSteps, closeAllSteps, StepComponent } = useSteps();
  const isAllStepsOpen = StepComponent === AllSteps;

  const handleClick = () => {
    if (isAllStepsOpen) {
      closeAllSteps();
    } else {
      openAllSteps();
    }
  };

  return (
    <button
      className={`p-2 ml-4 rounded-lg transition-colors ${
        isCameraActive ? "" : "border hover:bg-[#282F44]/20"
      }`}
      onClick={handleClick}
      title={isAllStepsOpen ? "Close all steps" : "Go to all steps"}
    >
      <StepsSvg
        style={{ width: "24px", height: "24px" }}
        className={isCameraActive ? "fill-white" : "fill-[#A1A7C2]"}
      />
    </button>
  );
};
